import { render, staticRenderFns } from "./commonuse.vue?vue&type=template&id=54ffe3b3&scoped=true&"
import script from "./commonuse.vue?vue&type=script&lang=js&"
export * from "./commonuse.vue?vue&type=script&lang=js&"
import style0 from "./commonuse.vue?vue&type=style&index=0&id=54ffe3b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ffe3b3",
  null
  
)

export default component.exports